import React, { Component, useEffect, useState } from "react";
import "./become-a-kzen-partner.scss";

import { useWindowSize } from "@react-hook/window-size/throttled";
import LazyLoad from "react-lazyload";
import WhatOthersSay from "../../sections/what-others-say/what-others-say";
import Marquee from "react-fast-marquee";
import StrokePattern from "../../components/stroke-pattern/stroke-pattern";
import { Button } from "@mui/material";
import { BsFillArrowRightCircleFill } from "react-icons/bs";
import { Link } from 'react-router-dom';
import { IoChatbox } from "react-icons/io5";

const BecomeAKzenPartner = () => {


  const [width, height] = useWindowSize();
  const [playerSize, setPlayerSize] = useState("768px");

  useEffect(() => {
    if (width > 1420) {
      setPlayerSize("512px");
    }
    else if (width > 720) {
      setPlayerSize("420px");
    } else {
      setPlayerSize("320px");
    }

  }, [width]);


  return (

    <div className="becomeAKzenPartner full-width-element" >
      {/* <img src="/images/wave-1.svg" className="backgroundColourWave1"></img> */}
      <StrokePattern styles={{ position: 'absolute', width: '125px', top: '120px', left: '-10px' }} />

      <div className="heroSection">
        <div className="leftSection animated slideUpAnimation initially-hidden body">



          <h1 className="bannerHeading tertiary-dark-text" id="becomeAKzenPartner">Generate Income
            <br /><span className="primary-text">With <span className="tertiary-text">Kzen8</span></span>
            <br />

            {/* <span className="primary-text">Kzen</span><span className="tertiary-text">8</span> */}

          </h1>


          <span className="body    delay-1-half">Kzen8 delivers game changing opportunities not only to the way
            businesses operate, but also to consultants and industry experts who
            want to deliver massive added value to their clients. <br></br><br></br>
            Generate revenue for yourself by helping businesses get
            the systems they need to operate effectively. No software development skills required. <br></br><br></br></span>

          <div className="buttonContainer">
            <Link to="https://calendar.app.google/1gCWy6CNrMPb65Z36" target='blank'>
              <Button className="btn btn-tertiary callToAction subtitle2" variant="contained" endIcon={<IoChatbox />}>
                Let's Chat
              </Button>
            </Link>
          </div>



        </div>
        <div className="rightSection">
          <StrokePattern styles={{ position: 'absolute', width: '125px', top: 0, right: '-100px' }} />

          <video src="/videos/8 Ways of Making Money with Kzen8 today!.mp4" playsInline="true" autoPlay="true" muted="false" controls alt="Kzen8 - Partner Expert">
            <track default kind="captions" srclang="en" src="/subtitles/captions from 8 Ways video.vtt" />
          </video>

          <StrokePattern styles={{ position: 'absolute', width: '225px', left: '-450px' }} />



        </div>
      </div>



      {/* <div className="testimonialContainer">
        <Marquee gradientColor={[247, 247, 247]} speed={20} gradientWidth={width > 968 ? 200 : width > 720 ? 100 : 50}>
          {[1, 2, 3, 1, 2, 3].map((num, idx) => (
            <span key={idx} className="testimonial subtitle2">
              <img src={`/images/testimonial 3 (${num}).png`} />
            </span>
          ))}
        </Marquee>
      </div> */}

      <div className="comparisonSection">
        <div className="leftSection">
          <h1 className="header tertiary-text">We Can Do It</h1>

          <span className="body">
            Kzen8 can turn your ideas into usable software
            solutions that look and work exactly the way
            you want.
          </span>

          <br />

          <span className="body">
            Sell the solutions and receive

            <span className="header primary-text"> 30% </span> of all ongoing license fees.
          </span>

          <div className="example body">

            <p>
              <div className="heroImage">

              </div>
              <span>
                Murray Spiers, a
                Compliance Consultant,
                worked with Kzen8 to
                create software for the
                industry he knows best.
                <br />
                <br />

                Murray had the vision.
                Kzen8 brought it to life.
                <br />
                <br />

                Leveraging his established network, Murray now sells the
                platform and receives a percentage of all ongoing licence
                fees.
              </span>


            </p>

          </div>
        </div>

        <div className="rightSection">
          <h1 className="header tertiary-text">You Can Do It</h1>
          <span className="body">
            Create any business software solution
            without having to write a single line of code.
          </span>

          <br />

          <span className="body">
            <span className="header primary-text">
              Create it. Clone it. Sell it. </span>
          </span>


          <p className="example body">

            <video src="/videos/CRM Blueprint Demo 2024 03.mp4" playsInline="true" autoPlay="true" muted="false" controls alt="Kzen8 - Partner Expert"></video>
            <span>
              Start with one of our blueprints or build
              from the ground up.

              <br />
              <br />

              Configure the data set,
              functionality, process flow… all the way to
              button colour and font size.


              As many times as you want.
            </span>

          </p>


        </div>
      </div>

    </div>
  );
}

export default BecomeAKzenPartner;
